import { Outlet } from 'react-router-dom'
import { NavBar } from './NavBar'
import styles from './RootLayout.module.css'

/**
 * App shell: a skip link, persistent primary navigation, and the routed
 * content region. Screens render into the `<Outlet />`.
 */
export function RootLayout() {
  return (
    <div className={styles.shell}>
      <a className={`${styles.skipLink} visually-hidden`} href="#main">
        Skip to content
      </a>
      <NavBar />
      <main id="main" className={styles.main} tabIndex={-1}>
        <div className={styles.content}>
          <Outlet />
        </div>
      </main>
    </div>
  )
}
